import { Button, Input, Text } from '#atoms';
import { PATH } from '#const/path';
import { useLectureSearchQuery } from '#hooks/queries/lecture/useLectureSearchQuery';
import { useScheduleManage } from '#providers/SchedulesManage';
import { useUserInfo } from '#providers/UserInfo';
import { useState } from 'react';
import { useNavigate } from 'react-router';
import {
  ButtonBox,
  Container,
  Header,
  List,
  SearchFailBox,
  User
} from './styles';

export function WeeklyCalenderSearchLecture() {
  const navigate = useNavigate();
  const { userInfo } = useUserInfo();

  const coachId = (userInfo && userInfo?.id) || '';

  const [searchValue, setSearchValue] = useState<string>('');
  const { selectedLecture, setSelectedLecture, setGroupMembers } =
    useScheduleManage();
  const { data: lectureList } = useLectureSearchQuery(coachId, searchValue);

  const selectLecture = (
    name: string,
    id: string,
    rounds: number,
    isGroup: boolean
  ) => {
    setSelectedLecture({
      lectureId: id,
      lectureName: name,
      totalRound: rounds,
      isGroup
    });

    if (!isGroup) setGroupMembers([]);

    navigate(-1);
  };

  return (
    <Container>
      <Header>
        <Text>수업 목록</Text>
      </Header>
      <div>
        <Input
          type="text"
          placeholder="수업을 검색해주세요"
          value={searchValue}
          onChange={e => setSearchValue(String(e))}
        />
      </div>
      <List>
        {lectureList && lectureList.length === 0 ? (
          <SearchFailBox>
            <Text>검색 결과가 없습니다.</Text>
          </SearchFailBox>
        ) : (
          lectureList?.map(item => (
            <User
              key={item.id}
              isSelected={item.id === selectedLecture.lectureId}
              onClick={() => {
                // 마지막으로 선택한 수업 정보를 localStorage에 저장
                localStorage.setItem('selectedLecture', JSON.stringify(item));
                selectLecture(item.title, item.id, item.rounds, item.isGroup);
              }}
            >
              <Text>{item.title}</Text>
            </User>
          ))
        )}
        <ButtonBox>
          <Button
            background="transparent"
            onClick={() => navigate(PATH.PROFILE_CLASS_FORM)}
          >
            + 수업추가하기
          </Button>
        </ButtonBox>
      </List>
    </Container>
  );
}
